var styleDataHash = "78b262a7";
const injectCss = () => {
  var css = `.glob_fontElementMap,.i74ux{font-family:var(--ricos-font-family,unset)}._40AHO{color:var(--ricos-settings-text-color,#000);width:100%}[dir] ._40AHO{background-color:#fff}._40AHO.kC2hK{color:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff))}@supports not (contain:inline-size){@media only screen and (max-width:640px){._40AHO{height:47px}}}@container (width < 640px){._40AHO{height:47px}}._40AHO .aPpiM{align-items:center;display:grid;grid-auto-columns:max-content auto max-content;grid-auto-flow:column;height:40px;grid-gap:12px}[dir=ltr] ._40AHO .aPpiM,[dir=rtl] ._40AHO .aPpiM{padding-left:20px;padding-right:20px}@supports not (contain:inline-size){@media only screen and (max-width:640px){._40AHO .aPpiM.qrnXq{grid-auto-columns:auto}}}@container (width < 640px){._40AHO .aPpiM.qrnXq{grid-auto-columns:auto}}._40AHO .aPpiM .z0MRL{align-self:left}@supports not (contain:inline-size){@media only screen and (max-width:640px){._40AHO .aPpiM .z0MRL{display:flex;width:100%}}}@container (width < 640px){._40AHO .aPpiM .z0MRL{display:flex;width:100%}}._40AHO .aPpiM .RMfz5{display:grid;grid-auto-flow:row}._40AHO .aPpiM .RMfz5 .hjsPw{font-size:14px}._40AHO .aPpiM .RMfz5 .wEbAP{color:#646464;font-size:12px}._40AHO .aPpiM ._4gBD6{align-self:right}._40AHO:focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}._40AHO.kC2hK,._40AHO:active{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}[dir] ._40AHO.kC2hK,[dir] ._40AHO:active{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-fallback-tuple,2,97,255)),.1)}._40AHO.kC2hK svg,._40AHO:active svg{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff));fill:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}[dir] ._40AHO:hover{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.05);cursor:pointer}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var list_item_select_default = {
  "fontElementMap": "i74ux",
  "container": "_40AHO",
  "selected": "kC2hK",
  "content": "aPpiM",
  "content_mobile_alignCenter": "qrnXq",
  "prefix": "z0MRL",
  "titleWrapper": "RMfz5",
  "title": "hjsPw",
  "subtitle": "wEbAP",
  "suffix": "_4gBD6"
};
export {
  list_item_select_default as default,
  injectCss
};
//# sourceMappingURL=list-item-select-scss.js.map
